/**
 * default player value
 */
export const defQuality = 0;
export const defVolume = 0.66;
